import React from 'react';
import { AppState } from 'app/store';
import { connect } from 'react-redux';
import WithFontsForLanguage, { IProps } from 'app/components/layout/WithFontsForLanguage';
import { useI18n } from 'app/components/localization';
import { Lesson, LessonHeader } from 'app/constants/schemas';
import { EntityStringId } from 'app/types/entity';
import { maybeGetEntityOfType } from 'app/models/entities/selectors';

export const WithFontsForActiveLocale = (props: IProps) => {
  const { locale } = useI18n();
  return <WithFontsForLanguage languageCode={locale} {...props} />;
};

const getLessonOrLessonHeader = (state: AppState, id: EntityStringId) => {
  const lesson = maybeGetEntityOfType(state, Lesson, id);
  const lessonHeader = maybeGetEntityOfType(state, LessonHeader, id);
  if (lesson && lessonHeader) {
    return lesson.lock_version > lessonHeader.lock_version ? lesson : lessonHeader;
  } else {
    return lesson ?? lessonHeader;
  }
};
export const WithFontsForLessonLanguage = connect((state: AppState, { id }: { id?: EntityStringId }) => {
  const languageCode = id ? getLessonOrLessonHeader(state, id)?.language.id : undefined;
  return languageCode ? { languageCode } : {};
}, {})(WithFontsForLanguage);
